import type { AccountModulesState } from 'store/slices/accountModules';
import { isAccountModuleEnabled, type AccountModuleId } from 'types/account/accountModules';

/** Mega menu item id → account module flag from Make.com webhook. */
export const MENU_ITEM_ACCOUNT_MODULE: Partial<Record<string, AccountModuleId>> = {
  broadcasts: 'massMessaging',
  workflows: 'bots',
  flowise: 'aiBots',
  signer: 'documentSigning',
  AISupport: 'ai',
  'orders-agent': 'ordersAgent',
};

export const ACCOUNT_MODULE_UPGRADE_PATH = '/account/about';

export function isMenuItemModuleInactive(
  menuItemId: string,
  accountModules: AccountModulesState,
): boolean {
  const moduleId = MENU_ITEM_ACCOUNT_MODULE[menuItemId];
  if (!moduleId) return false;
  if (!accountModules.isLoaded || accountModules.hasError || !accountModules.data) return false;
  return !isAccountModuleEnabled(accountModules.data, moduleId);
}
